import { union } from 'lodash';
import { FormEvent, KeyboardEvent } from 'react';

export const numericKeyDownHandler =
  (allowFloats = false, allowNegatives = false, allowScientific = false) =>
  (event: KeyboardEvent<HTMLInputElement>) => {
    const invalids = union(
      allowFloats ? [] : ['.'],
      allowNegatives ? [] : ['-'],
      allowScientific ? [] : ['e'],
      ['+'],
    );

    if (invalids.includes(event.key)) {
      event.preventDefault();
    }
  };

export const positiveIntegerInputHandler =
  (min?: number, max?: number) => (event: FormEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;

    target.value = (target.value ?? '').replace(/[^0-9]*/g, '');

    if (target.value === '') {
      return;
    }

    const int = parseInt(target.value, 10);

    if (max != null && int > max) {
      target.value = max.toString();
    }

    if (min != null && int < min) {
      target.value = min.toString();
    }
  };
